import React, { memo, useState } from "react";
import { Tabs, Tab } from "react-bootstrap";

import StarRating from "../../StarRating/StarRating";
import {
  ChartIncludeColumn,
  DrawChart,
  DrawChart1,
} from "../../Chart/ChartInclude";
import { downloadExcel, NORECORDS } from "../../../Services/CommonLibrary";
import Programmestab from "./Programmestab";
import PracticeTable from "./PracticeTable";
import DivisionTable from "./DivisionTable";
import { formatUkNumber } from "../../../WebPages/Utils";

const ChartsSection = ({
  seriesGraph,
  coachRatingData,
  graphDuration,
  companyId,
  color,
  programmeColors,
  inclinicColors,
  dailyCategorization,
  callDetails,
  messageDetails,
  ageColorsDetails,
  filterForm,
  coachRatingLoading,
  setSeriesGraph, // Added to allow setting seriesGraph from this component
  onSelect
}) => {
  const { startRange, endRange, divisionClinicFilter, programSelect } =
    filterForm;


  const [selectedTab, setSelectedTab] = useState('first');
  const [programesData, setProgramesData] = useState([]);
  const [programLoading, setProgramLoading] = useState(false);
  const new_data_2 = ((seriesGraph?.new_data ? seriesGraph?.new_data_2 : []) ?? []);
  // console.log('new_data_2', new_data_2)
  const rawData = ((seriesGraph?.new_data ? seriesGraph?.new_data : []) ?? []).filter((i) => {
    switch (selectedTab) {
      case "first":
        if (divisionClinicFilter.division.length == 0) {
          return true;
        }
        return [...divisionClinicFilter.division, 0].includes(Number(i.areaId));
      case "second":
        if (divisionClinicFilter.clinic.length == 0) {
          return true;
        }
        return [...divisionClinicFilter.clinic, 0].includes(Number(i.clinicId));
      case "third":
        return true;
    }
  });

  const mergedDataMap = new Map();
  rawData.forEach(item => {
    let name = "";
    switch (selectedTab) {
      case "first":
        name = item.areaName;
        break;
      case "second":
        name = item.clinicName;
        break;
      case "third":
        name = item.name;
        break;
    }
    // const name = item.areaName || item.name; // use areaName if exists

    if (!name) {
      name = 'None'; // skip if name is undefined
    }


    if (!mergedDataMap.has(name)) {
      mergedDataMap.set(name, {
        name,
        cnt: Number(item.cnt) || 0,
        onboardedUser: Number(item.onboardedUser) || 0,
        inclinic: Number(item.inclinic) || 0,
        areaId: item.areaId,
        clinicId: item.clinicId,
        programId: item.programId,
      });
    } else {
      const existing = mergedDataMap.get(name);
      existing.cnt += Number(item.cnt) || 0;
      existing.onboardedUser += Number(item.onboardedUser) || 0;
      existing.inclinic += Number(item.inclinic) || 0;
    }
  });

  const _data = Array.from(mergedDataMap.values()).map((i) => {
    console.log(Number(i.areaId))
    switch (selectedTab) {
      case "first":
        return {
          ...i,
          inclinic: new_data_2.filter((j) => {
            return Number(i.areaId) === Number(j.areaId);
          }).reduce((sum, j) => sum + Number(j.cnt || 0), 0)
        }
      case "second":
        return {
          ...i,
          inclinic: new_data_2.filter((j) => {
            return Number(i.clinicId) === Number(j.clinicId);
          }).reduce((sum, j) => sum + Number(j.cnt || 0), 0)
        }

      case "third":
        return {
          ...i,
          inclinic: new_data_2.filter((j) => {
            return Number(i.programId) === Number(j.programId);
          }).reduce((sum, j) => sum + Number(j.cnt || 0), 0)
        }
    }
    return i;
  });

  // const divisonData = seriesGraph.divisionCategory.map((_, index) => {
  //   const name =
  //     seriesGraph.divisionCategory[index] || "N/A";
  //   const accountCreatedSeries =
  //     seriesGraph.divisionSeries.find(
  //       (s) => s.name === "Accounts Created"
  //     );
  //   const fullyOnboardedSeries =
  //     seriesGraph.divisionSeries.find(
  //       (s) => s.name === "Fully Onboarded"
  //     );
  //   const inclinicAppointmentsSeries =
  //     seriesGraph.divisionSeries.find(
  //       (s) => s.name === "Inclinic Appointments"
  //     );
  //   const accountCreated =
  //     accountCreatedSeries?.data?.[index] || 0;
  //   const fullyOnboarded =
  //     fullyOnboardedSeries?.data?.[index] || 0;
  //   const inclinicAppointments =
  //     inclinicAppointmentsSeries?.data?.[index] || 0;
  //   return {
  //     name,
  //     accountCreated,
  //     fullyOnboarded,
  //     inclinicAppointments
  //   };
  // });

  // const practiceData = seriesGraph.divisionPracticeCategory.map(
  //   (name, index) => {
  //     const onboardedSeries =
  //       seriesGraph.divisionPracticeSeries.find(
  //         (s) => s.name === "Accounts Created"
  //       );
  //     const activeSeries =
  //       seriesGraph.divisionPracticeSeries.find(
  //         (s) => s.name === "Fully Onboarded"
  //       );
  //     const onboarded = onboardedSeries?.data?.[index] || 0;
  //     const active = activeSeries?.data?.[index] || 0;
  //     return {
  //       name,
  //       onboarded,
  //       active
  //     };
  //   }
  // );

  const handleSeelctTab = (val) => {
    if (selectedTab != val) {
      setSelectedTab(val);
      onSelect && onSelect(val);
    }
  }
  const handleDownlaodExcel = () => {
    let name = '';
    if (startRange || endRange) {
      name = `${startRange}_to_${endRange}_`;
    }

    let _fileds = [
      { key: 'name', name: "Name" },
      { key: 'cnt', name: "Account Created" },
      { key: 'onboardedUser', name: "Fully Onboarded" },
    ];
    switch (selectedTab) {
      case "first":
        name = `${name}divison`;
        _fileds.push({ key: 'inclinic', name: "In-clinic Appointments" });
        break;
      case "second":
        name = `${name}practice`;
        _fileds.push({ key: 'inclinic', name: "In-clinic Appointments" });
        break;
      case "third":
        name = `${name}programmes`;
        break;
    }

    downloadExcel(_fileds, _data, name);
    
  }

  return (
    console.log('seriesGraph in chartsection', seriesGraph),
    <div className="row">
      {/* Programs Chart */}
      <div className="col-md-6 pe-5 line-r">
        <div className="row">
          <div className="col-8">
            <h1 className="title">Programmes</h1>
          </div>
        </div>
        {seriesGraph.loadingStates.program_graph ? (
          <div className="text-center my-5">
            <div
              style={{ color: "#535f7e" }}
              className="spinner-border"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">Loading program data...</p>
          </div>
        ) : seriesGraph.program_graph_series.data &&
          seriesGraph.program_graph_series.data.length > 0 ? (
          <DrawChart1
            series={seriesGraph.program_graph_series}
            chartType="pie"
            color={programmeColors}
          />
        ) : (
          <NORECORDS />
        )}
      </div>

      <hr className="line d-sm-none" />

      <div className="col-md-6 ps-5" style={{ display: "block" }}>
        <div className="row">
          <div className="col-12">
            <h1 className="title">Coach Rating</h1>
          </div>
        </div>
        {coachRatingLoading ? (
          <div className="text-center my-5">
            <div
              style={{ color: "#535f7e" }}
              className="spinner-border"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">Loading coach rating data...</p>
          </div>
        ) : coachRatingData?.length > 0 ? (
          <StarRating
            data={coachRatingData}
            startRange={startRange}
            endRange={endRange}
            divisionClinicFilter={divisionClinicFilter}
            programSelect={programSelect}
          />
        ) : <NORECORDS />}
      </div>

      <hr className="line" />

      {/* Division/Practice Tabs */}
      <div className="col-md-12 ps-5">
        <div style={{ display: "block", padding: "10px", position: "relative" }}>

          <Tabs onSelect={handleSeelctTab} defaultActiveKey="first">

            <Tab eventKey="first" title="Divisions" mountOnEnter unmountOnExit>
              <div className="row">
                <div className="col-12">
                  <h1 className="title">Divisions-wise Categorisation</h1>
                </div>
              </div>
              <DivisionTable loadingMessage="Loading divison data..." loading={seriesGraph.loadingStates.division_graph}
                data={_data} />

            </Tab>
            <Tab eventKey="second" title="Practices" mountOnEnter unmountOnExit>
              <div className="row">
                <div className="col-12">
                  <h1 className="title">Practices-wise Categorisation</h1>

                </div>
              </div>
              <DivisionTable loadingMessage="Loading Practice data..." loading={seriesGraph.loadingStates.division_graph}
                data={_data} />
              {/* <PracticeTable
                data={seriesGraph?.new_data??[]}
                loading={seriesGraph.loadingStates.division_practice_graph} /> */}
            </Tab>

            <Tab eventKey="third" title="Programmes" mountOnEnter unmountOnExit>
              <div className="row">
                <div className="col-12">
                  <h1 className="title">Programmes-wise Categorisation</h1>
                </div>
              </div>
              <DivisionTable loadingMessage="Loading Programmes data..." isClinic={false} loading={seriesGraph.loadingStates.division_graph}
                data={_data} />
              {/* <PracticeTable
                data={seriesGraph?.new_data??[]}
                loading={seriesGraph.loadingStates.division_practice_graph} /> */}
              {/* {seriesGraph.loadingStates.program_graph ? (
                <div className="text-center my-5">
                  <div
                    style={{ color: "#535f7e" }}
                    className="spinner-border"
                    role="status"
                  >
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <p className="mt-2">Loading programmes data...</p>
                </div>
              ) : (
                <Programmestab
                  loading={programLoading}
                  setLoading={setProgramLoading}
                  startRange={startRange}
                  endRange={endRange}
                  divisionClinicFilter={divisionClinicFilter}
                  programSelect={programSelect}
                  data={programesData}
                  setProgramesData={setProgramesData}
                />
              )} */}
            </Tab>
          </Tabs>
          <div style={{ position: 'absolute', right: 10, top: 10 }}>
            <button
              onClick={handleDownlaodExcel}
              className="btn btn-success btn-sm"
              disabled={(
                seriesGraph.loadingStates.division_graph || seriesGraph.loadingStates.division_practice_graph || (
                  selectedTab == "third" && programLoading
                )
              )}
            >Export </button>
          </div>
        </div>
      </div>

      <hr className="line" />

      {/* Date Categorisation Chart */}
      <div
        className={companyId == 1 ? "col-md-6 pe-5 line-r" : "col-md-12 pe-5"}
      >
        <div className="row">
          <div className="col-12">
            <h1 className="title">{graphDuration}Categorisation</h1>
          </div>
        </div>
        {seriesGraph.loadingStates.division_date_graph ? (
          <div className="text-center my-5">
            <div
              style={{ color: "#535f7e" }}
              className="spinner-border"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">Loading  data...</p>
          </div>
        ) : seriesGraph.divisionDateCategory &&
          seriesGraph.divisionDateCategory.length > 0 ? (
          <ChartIncludeColumn
            series={seriesGraph.divisionDateSeries}
            category={seriesGraph.divisionDateCategory}
            chartType="column"
            color={dailyCategorization}
          />
        ) : (
          <NORECORDS />
        )}
      </div>
      {/* In-clinic Appointments (conditional) */}
      {companyId == 1 ? (
        <div className="col-md-6 ps-5">
          <hr className="line d-sm-none" />
          <div className="row">
            <div className="col-md-12">
              <h1 className="title">In-clinic Appointments</h1>
            </div>
          </div>
          {seriesGraph.loadingStates.inclinic_call_graph ? (
            <div className="text-center my-5">
              <div
                style={{ color: "#535f7e" }}
                className="spinner-border"
                role="status"
              >
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2">Loading in-clinic call data...</p>
            </div>
          ) : seriesGraph.inclinicCallSeries.data &&
            seriesGraph.inclinicCallSeries.data.length > 0 ? (
            <DrawChart
              series={seriesGraph.inclinicCallSeries}
              chartType="pie"
              color={inclinicColors}
            />
          ) : (
            <NORECORDS />
          )}
        </div>
      ) : (
        ""
      )}

      <hr className="line" />

      {/* Gender Chart */}
      <div className="col-md-6 pe-5 line-r">
        <div className="row">
          <div className="col-8">
            <h1 className="title">Gender</h1>
          </div>
        </div>
        <DrawChart
          series={seriesGraph.gender_graph_series}
          chartType="pie"
          color={color}
        />
      </div>

      <hr className="line d-sm-none" />

      {/* Age Chart */}
      <div className="col-md-6 ps-5">
        <div className="row">
          <div className="col-md-12">
            <h1 className="title">Age</h1>
          </div>
        </div>
        <DrawChart series={seriesGraph.age_graph_series} chartType="pie" color={ageColorsDetails} />
      </div>

      <hr className="line" />

      {/* Call Details Chart */}
      <div className="col-md-6 pe-5 line-r">
        <div className="row">
          <div className="col-8">
            <h1 className="title">Call Details</h1>
          </div>
        </div>
        {seriesGraph.loadingStates.call_detail_graph ? (
          <div
            className="text-center my-5"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
            }}
          >
            <div
              style={{ color: "#535f7e" }}
              className="spinner-border"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">Loading call data...</p>
          </div>
        ) : seriesGraph.callDetailSeries &&
          seriesGraph.callDetailSeries.length > 0 ? (
          <ChartIncludeColumn
            series={seriesGraph.callDetailSeries}
            category={seriesGraph.callDetailCategory}
            chartType="column"
            color={callDetails}
          />
        ) : (
          <NORECORDS />
        )}
      </div>

      <hr className="line d-sm-none" />

      {/* Message Details Chart */}
      <div className="col-md-6 ps-5">
        <div className="row">
          <div className="col-md-12">
            <h1 className="title">Message Details</h1>
          </div>
        </div>
        {seriesGraph.loadingStates.message_graph ? (
          <div
            className="text-center my-5"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              minHeight: "400px",
            }}
          >
            <div
              style={{ color: "#535f7e" }}
              className="spinner-border"
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <p className="mt-2">Loading message data...</p>
          </div>
        ) : seriesGraph.mesageGraphSeries &&
          seriesGraph.mesageGraphSeries.length > 0 ? (
          <ChartIncludeColumn
            series={seriesGraph.mesageGraphSeries}
            category={seriesGraph.mesageGraphCategory}
            chartType="column"
            color={messageDetails}
          />
        ) : (
          <NORECORDS />
        )}
      </div>
    </div>
  );
};

export default memo(ChartsSection);
